import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'ti' },
  { name: 'au' },
  { name: 'mh' },
  { name: 'mj' }
]

const defaultSyntaxGuideUrl = 'https://bvsalud.org/en/how-to-search/#menu-access'

class VhlEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Virtual Health Library')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  formulateQuery (query) {
    return 'https://search.bvsalud.org/portal/?&q=' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}
export default VhlEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/VhlEngine.js